import { render, staticRenderFns } from "./IndexChart.vue?vue&type=template&id=69ba1f7e&scoped=true"
import script from "./IndexChart.vue?vue&type=script&lang=js"
export * from "./IndexChart.vue?vue&type=script&lang=js"
import style0 from "./IndexChart.vue?vue&type=style&index=0&id=69ba1f7e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba1f7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ba1f7e')) {
      api.createRecord('69ba1f7e', component.options)
    } else {
      api.reload('69ba1f7e', component.options)
    }
    module.hot.accept("./IndexChart.vue?vue&type=template&id=69ba1f7e&scoped=true", function () {
      api.rerender('69ba1f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/IndexChart.vue"
export default component.exports